module.exports = __webpack_public_path__ + "static/media/1.cbe83032.jpg";